import { gql } from "@apollo/client";

export const GET_ALL_TIPO_PLAN = gql`
query GetAllTipoPlan {
    allTipoPlan{
            idTipoPlan,
            descripcion
      }
}`;